import React from "react";

export default function CircleAlertIcon() {
  return (
    <svg
      width="65"
      height="64"
      viewBox="0 0 65 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_1175_3739)">
        <path
          d="M32.5 0C50.164 0 64.5 14.336 64.5 32C64.5 49.664 50.164 64 32.5 64C14.836 64 0.5 49.664 0.5 32C0.5 14.336 14.836 0 32.5 0ZM32.5 4.2688C17.2104 4.2688 4.7688 16.7104 4.7688 32C4.7688 47.2896 17.2104 59.7312 32.5 59.7312C47.7896 59.7312 60.2312 47.2896 60.2312 32C60.2312 16.7104 47.7896 4.2688 32.5 4.2688Z"
          fill="#FF574D"
        />
        <path
          opacity="0.4"
          d="M34.119 15.9233L34.2726 16.1537L34.4134 16.3969L49.1334 43.5137C50.1446 45.3761 49.3318 46.9057 47.3222 47.0337L47.0406 47.0401H17.959C15.8406 47.0401 14.8934 45.5937 15.7446 43.7633L15.8662 43.5137L30.5862 16.3969C31.5462 14.6177 33.0566 14.4641 34.119 15.9233ZM32.4998 38.6049L32.2758 38.6177C31.3222 38.7201 30.567 39.4561 30.4518 40.3777L30.439 40.6145L30.4518 40.8321C30.5542 41.7665 31.3094 42.5025 32.2566 42.6113L32.4998 42.6241L32.7238 42.6113C33.6774 42.5153 34.4326 41.7793 34.5478 40.8513L34.5606 40.6145L34.5478 40.3969C34.4454 39.4689 33.6902 38.7265 32.743 38.6177L32.4998 38.6049ZM32.4998 22.5217L32.2758 22.5345C31.3222 22.6369 30.567 23.3729 30.4518 24.3009L30.439 24.5313V34.5857C30.439 35.6225 31.2454 36.4737 32.2758 36.5825L32.4998 36.5953L32.7238 36.5825C33.6774 36.4801 34.4326 35.7505 34.5478 34.8225L34.5606 34.5857V24.5313C34.5606 23.4241 33.639 22.5217 32.4998 22.5217Z"
          fill="#FF574D"
        />
      </g>
      <defs>
        <clipPath id="clip0_1175_3739">
          <rect
            width="64"
            height="64"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
